import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="spinner-border" style={{ position: 'absolute', justifyContent: 'center', alignItems: 'center', display: 'block' }} role="status">
        </div>
    );
};

export default LoadingSpinner;